import { AxiosResponse } from 'axios';

import api from '@/services/api';
import {
  IAuthData,
  IAuthOtp,
  ILogin,
  ILoginConfirm,
  IPasswordResetBody,
} from '@/services/requests/auth/Auth.types';
import { IApiResponse } from '@/types/interfaces';
import { isPublicHost } from '@/utils/isProduction';

export const AuthRequests = {
  authorization({ login, password }: ILogin): Promise<IApiResponse<IAuthData | IAuthOtp>> {
    const path = isPublicHost() ? '/authorization' : '/authorization/admin';
    return api.post<IAuthData>(
      path,
      {
        login: login.toLowerCase(),
        password,
      },
      {
        meta: {
          preventLogoutOnUnauthorized: true,
        },
      }
    );
  },

  authorizationConfirm({ login, otp }: ILoginConfirm): Promise<IApiResponse<IAuthData>> {
    return api.post('/authorization/confirm', {
      login: login.toLowerCase(),
      otp,
    });
  },

  authorizationResendOtpCode(login: string) {
    return api.post('/authorization/resend-otp', { login });
  },

  passwordRecovery(login: string) {
    return api.post('/password/recovery', { login });
  },

  passwordReset(data: IPasswordResetBody) {
    return api.post('/password/recovery/confirm', data);
  },

  resendOtpCode(login: string): Promise<IApiResponse<any>> {
    return api.post('/registration/resend-otp', { login });
  },

  refreshToken(refreshToken: string): Promise<AxiosResponse<IAuthData>> {
    return api.post<IAuthData>('/authorization/refresh', refreshToken, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: true,
      },
    });
  },
};
